import { render, staticRenderFns } from "./HotkeysModal.vue?vue&type=template&id=776b5494&scoped=true&"
import script from "./HotkeysModal.vue?vue&type=script&lang=js&"
export * from "./HotkeysModal.vue?vue&type=script&lang=js&"
import style0 from "./HotkeysModal.vue?vue&type=style&index=0&id=776b5494&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776b5494",
  null
  
)

export default component.exports